import axios from 'axios';
import config from '../config';

export const getUrlBAYKTRApi = async (longUrl) => {
    const url = `${config.b_ayk_tr.url}?service=${config.b_ayk_tr.service}&address=${longUrl}&redirect=direct`;
    return await axios.post(url).then(response => response.data);
} 